import React from "react";
import SearchTool from "./pages/SearchTool";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Dashboard from "./pages/Dashboard";
import ManagerDashboard from "./pages/ManagerDashboard";
import Reports from "./pages/Reports";
import Login from "./pages/auth/login";
import Register from "./pages/auth/register";
import ScanTool from "./pages/ScanTool";
import Database from "./pages/Database";
import { LoadingProvider } from "./utils/loading/LoadingContext";
import LoadingIndicator from "./utils/loading/LoadingIndicator";
import ProtectedRoute from "./ProtectedRoute";
import { AuthProvider } from "./pages/auth/AuthContext";
import AdminRoute from "./AdminRoute";
import BiddingSheet from "./pages/BiddingSheet";
import Pallets from "./pages/Pallets";
import ScanToPallet from "./pages/ScanToPallet";
import RemoveFromPallet from "./pages/RemoveFromPallet";
import PalletView from "./pages/PalletView";
import PriceDispute from "./pages/PriceDispute";
import Settings from "./pages/Settings";
import MeilyWoocommerce from "./pages/MeilyWoocommerce";
import MeilyJtlWawi from "./pages/MeilyJtlWawi";
import PalletScanSelection from "./pages/PalletScanSelection";
import FeatureSuggestion from "./pages/FeatureSuggestion";

function App() {
  return (
    <LoadingProvider>
      <Router>
        <LoadingIndicator />
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            <Route
              path="/"
              element={
                <AdminRoute>
                  <Dashboard />
                </AdminRoute>
              }
            />
            <Route
              path="/searchtool"
              element={
                <AdminRoute>
                  <SearchTool />
                </AdminRoute>
              }
            />

            <Route
              path="/reports"
              element={
                <AdminRoute>
                  <Reports />
                </AdminRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <AdminRoute>
                  <Settings />
                </AdminRoute>
              }
            />
             <Route
              path="/feature-suggestion"
              element={
                <AdminRoute>
                  <FeatureSuggestion />
                </AdminRoute>
              }
            />
            <Route
              path="/price-dispute"
              element={
                <AdminRoute>
                  <PriceDispute />
                </AdminRoute>
              }
            />
            <Route
              path="/bidding-sheet"
              element={
                <AdminRoute>
                  <BiddingSheet />
                </AdminRoute>
              }
            />
            <Route
              path="/pallets"
              element={
                <AdminRoute>
                  <Pallets />
                </AdminRoute>
              }
            />
             <Route
              path="/pallets/:palletNumber"
              element={
                <AdminRoute>
                  <PalletView />
                </AdminRoute>
              }
            />
            <Route
          path="/pallet-scan-selection"
          element={
            <AdminRoute>
              <PalletScanSelection />
            </AdminRoute>
          }
        />
            <Route
              path="/pallet-scan-selection/:palletNumber/scan"
              element={
                <AdminRoute>
                  <ScanToPallet />
                </AdminRoute>
              }
            />
            <Route
              path="/pallet-scan-selection/:palletNumber/remove"
              element={
                <AdminRoute>
                  <RemoveFromPallet />
                </AdminRoute>
              }
            />
            <Route
              path="/scantool"
              element={
                <AdminRoute>
                  <ScanTool />
                </AdminRoute>
              }
            />
            <Route
            path="/meily-woocommerce-orders"
            element={
              <ProtectedRoute>
                <MeilyWoocommerce />
              </ProtectedRoute>
            }
            />
             <Route
            path="/meily-jtl-wawi-orders"
            element={
              <ProtectedRoute>
                <MeilyJtlWawi />
              </ProtectedRoute>
            }
            />
            <Route
              path="/manager-dashboard"
              element={
                <ProtectedRoute>
                  <ManagerDashboard />
                </ProtectedRoute>
              }
            />
            
            {/* <Route path="/admin" element={<ProtectedRoute><Database /></ProtectedRoute>} /> */}
          </Routes>
        </AuthProvider>

        <LoadingIndicator />
      </Router>
    </LoadingProvider>
  );
}

export default App;
